import { writable, get } from 'svelte/store'

export interface ModalOptions {
  title?: string
  message: string
  confirmText?: string
  cancelText?: string
  showCancel?: boolean
  confirmButtonClass?: string
  type?: 'confirm' | 'alert' | 'save-confirm'
}

interface ModalState {
  isOpen: boolean
  options: ModalOptions | null
  resolve: ((value: boolean | 'save' | 'discard' | 'cancel') => void) | null
}

const modalStore = writable<ModalState>({
  isOpen: false,
  options: null,
  resolve: null
})

export const modal = {
  subscribe: modalStore.subscribe,
  
  confirm(options: ModalOptions | string): Promise<boolean> {
    return new Promise((resolve) => {
      const opts = typeof options === 'string' 
        ? { message: options, type: 'confirm' as const }
        : { ...options, type: 'confirm' as const }
      
      modalStore.set({
        isOpen: true,
        options: {
          title: '확인',
          confirmText: '확인',
          cancelText: '취소',
          showCancel: true,
          ...opts
        },
        resolve: (value) => resolve(value === true)
      })
    })
  },
  
  alert(options: ModalOptions | string): Promise<void> {
    return new Promise((resolve) => {
      const opts = typeof options === 'string' 
        ? { message: options, type: 'alert' as const }
        : { ...options, type: 'alert' as const }
      
      modalStore.set({
        isOpen: true,
        options: {
          title: '알림',
          confirmText: '확인',
          showCancel: false,
          ...opts
        },
        resolve: () => resolve()
      })
    })
  },
  
  saveConfirm(fileName: string): Promise<'save' | 'discard' | 'cancel'> {
    return new Promise((resolve) => {
      modalStore.set({
        isOpen: true,
        options: {
          type: 'save-confirm',
          title: '저장되지 않은 변경사항',
          message: `"${fileName}"에 저장되지 않은 변경사항이 있습니다.\n변경사항을 저장하시겠습니까?`,
          confirmText: '저장',
          cancelText: '저장 안 함',
          showCancel: true
        },
        resolve: (value) => {
          if (value === 'save') resolve('save')
          else if (value === 'discard') resolve('discard')
          else if (value === 'cancel') resolve('cancel')
          // For backward compatibility with boolean values
          else if (value === true) resolve('save')
          else if (value === false) resolve('discard')
          else resolve('cancel')
        }
      })
    })
  },
  
  close() {
    const state = get(modalStore)
    if (state.resolve) {
      state.resolve(false)
    }
    modalStore.set({
      isOpen: false,
      options: null,
      resolve: null
    })
  },
  
  confirm_result(value: boolean | 'save' | 'discard' | 'cancel') {
    const state = get(modalStore)
    if (state.resolve) {
      state.resolve(value)
    }
    modalStore.set({
      isOpen: false,
      options: null,
      resolve: null
    })
  }
}

export default modal